export default __webpack_public_path__ + "static/media/avatar.7be6c698.png";